// @ts-nocheck
/*
Gameboy cpu timers are as follows:

7    0 7    0
+-----+-----+
|  A  |  F  |
+-----+-----+
|  B  |  C  |
+-----+-----+
|  D  |  E  |
+-----+-----+
|  H  |  L  |
+-----+-----+

15           0
+------------+
|     PC     |
+------------+
|     SP     |
+------------+

CpuRegister A is the accumulator and stores the results of arithmetic and logic operations.

Registers besides A and F are auxiliary to the accumulator, or as pairs (BC, DE, HL) can be used as data pointers.

PC: Program Counter
16 bit register that holds the address of the program to be executed next. Incremented by the byte count of the
instruction.

SP: Stack Pointer
16 bit register that holds the starting address of the stack

CpuRegister F stores flags as follows:

  7   6   5   4    3   2   1   0
+---+---+---+----+---+---+---+---+
| z | n | H | CY | \ | \ | \ | \ |
+---+---+---+----+---+---+---+---+

Z is zero flag, should be set when the result of an operation is zero
N is subtraction flag, should be set following the execution of any subtraction instruction
H is half carry flag, set when borrowing to or carrying from bit 3, i.e. 0x15 + 2 wraps to 0x11, and flag should be set
CY is carry flag, set when borrowing to or carrying from bit 7, i.e. 255 + 2 wraps to 1, and flag should be set
 */
import { CpuRegister, DoubleCpuRegister } from "./cpu-register.js";
import { CpuFlagRegister } from "./cpu-flag-register.js";
export class CpuRegisterCollection {
    registersView;
    baseRegisters;
    registerPairs;
    F;
    A;
    C;
    B;
    E;
    D;
    L;
    H;
    AF;
    BC;
    DE;
    HL;
    programCounter;
    stackPointer;
    constructor() {
        this.registersView = new DataView(new ArrayBuffer(12));
        this.F = new CpuFlagRegister('F', 0, this.registersView, -1);
        this.A = new CpuRegister('A', 1, this.registersView, 0b111);
        this.C = new CpuRegister('C', 2, this.registersView, 0b001);
        this.B = new CpuRegister('B', 3, this.registersView, 0b000);
        this.E = new CpuRegister('E', 4, this.registersView, 0b011);
        this.D = new CpuRegister('D', 5, this.registersView, 0b010);
        this.L = new CpuRegister('L', 6, this.registersView, 0b101);
        this.H = new CpuRegister('H', 7, this.registersView, 0b100);
        this.AF = new DoubleCpuRegister('AF', 0, this.registersView, 0b11);
        this.BC = new DoubleCpuRegister('BC', 2, this.registersView, 0b00);
        this.DE = new DoubleCpuRegister('DE', 4, this.registersView, 0b01);
        this.HL = new DoubleCpuRegister('HL', 6, this.registersView, 0b10);
        this.programCounter = new DoubleCpuRegister('PC', 8, this.registersView, -1);
        this.stackPointer = new DoubleCpuRegister('SP', 10, this.registersView, 0b11);
        this.baseRegisters = [this.A, this.B, this.C, this.D, this.E, this.H, this.L];
        this.registerPairs = [this.AF, this.BC, this.DE, this.HL, this.stackPointer];
    }
    reset() {
        this.registersView = new DataView(new ArrayBuffer(12));
    }
}
//# sourceMappingURL=cpu-register-collection.js.map